import {
  PageCoco,
  PageCocoProfileUpdate,
  PageCocoRemoteConsent,
} from "./controls";

export const chinaControllerCode = "cn_ph";
export const HCP = "hcp";
export const COCO_ROLE = "online_coco_role";
export const CONFIG_READER_ROLE = "role_config_reader";

export const CREATED = "Created";
export const DELETED = "Deleted";

export const ADMIN_ROLE = "role_admin";
export const FORM_TYPE_DELETE_IDENTITY = "delete_identity";
export const FORM_TYPE_OPT_OUT = "OPT_OUT";

export const TrumanApplicationList = [
  {
    oid: "5ef74f7d-0134-4585-92b3-0a805c08eacb",
    displayName: "Instant Messaging Pharma - Test App",
  },
  {
    oid: "1d7fa931-4722-4bde-912e-29c54702fc2f",
    displayName: "Campaign Suggestion 2.0",
  },
  {
    oid: "688d5b09-04c4-4d64-95bb-878ae6e8df73",
    displayName: " Bayer Connect Universe",
  },
  {
    oid: "c65a1145-ee68-4d95-b45d-9f14c43f7a35",
    displayName: "COCO Mobile App PROD",
  },
  {
    oid: "ea8d56ea-94d2-4906-b24f-169abc94c0fd",
    displayName: "COCO Mobile App QA",
  },
  {
    oid: "a569cae0-6d60-4bf1-9c41-fee8206e0aa6",
    displayName: "Truman Consent Management",
  },
  {
    oid: "bea5203b-68de-4f0b-96ee-4d9b1ee1e6d3",
    displayName: "Truman Consent Management",
  },
];

export const NULL_VALUE = null;
export const EMPTY_STRING = "";
export const VAULT = "vault";
export const VAULT_ID = "vault_id";
export const usEmail = "Truman_Ops_US@bayer.com";
export const chinaEmail = "Truman_Ops_CN@bayer.com";
export const globalEmail = "Global_Truman_Support@bayer.com";
export const subject = "Truman UI - Request for Support";
export const varBayerID = "bayer_id";
export const varExtProviderID = "external_provider_id";
export const japanControllerCode = "jp_ph";
export const cocoUserAccessPages = [
  PageCoco,
  PageCocoRemoteConsent,
  PageCocoProfileUpdate,
];

export const PAPER_CONSENT="paper-consent";
export const PAPER_CONSENT_FRAGMENT="paper-consent-fragment";
export const COCO_LINK_TYPE_OPTIONS = [
  { label: "COCO Online", value: "cocoonline" },
  { label: "COCO App", value: "cocoapp" },
];
export const SOURCE_SYSYTEM_OPTIONS = [
  { label: "Veeva", value: "veeva" },
  { label: "Vault ID", value: "vault" },
  { label: "Balios", value: "balios" },
];
